import type { AssetTimelineCauserProps } from "./asset-timeline-causer.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { getAssetEventCauserModel } from "@/modules/asset-event";
import { CauserSubject } from "@/modules/causer-subject";

const { Text } = Typography;

export const AssetTimelineCauser = ({
  assetEvent,
  renderWrapper,
}: AssetTimelineCauserProps) => {
  const { t } = useTranslation();
  const { causer } = assetEvent;
  const causerModel = getAssetEventCauserModel(assetEvent);

  return renderWrapper(
    <Text>
      {`${t("asset:timeline.modifiedBy")}: `}
      <CauserSubject type="causer" model={causerModel} item={causer} />
    </Text>
  );
};
